



<div class="row">
  <div id="gm1" class="GaugeMeter"></div>
  <!-- <div id="gm3" class="GaugeMeter"></div> -->
  <div id="gm2" class="GaugeMeter"></div>
  <div id="gm4" class="GaugeMeter"></div>
  <!-- <div id="gm5" class="GaugeMeter"></div> -->
  <div id="gm6" class="GaugeMeter" *ngIf="showwalletPrePay"></div>
</div>



<!-- <button (click)="updateChart()" >Update GM2</button> -->

